import getContentEntriesByType from '@shared/services/content-service';
import type { ContentfulItem } from '@shared/types/contentful';
import { useQuery } from '@tanstack/react-query';

interface Props {
    contentType: string;
    includeDepth?: number;
    queryParams?: { key: string; value: string }[];
    enabled?: boolean;
}

export default function useContent<T>({
    contentType,
    includeDepth,
    queryParams,
    enabled = true,
}: Props) {
    return useQuery(
        ['contentByType', contentType, includeDepth, queryParams],
        async () => {
            const entries = await getContentEntriesByType<T>(contentType, {
                includeDepth: includeDepth,
                queryParams: queryParams,
            });

            if (entries?.items) {
                return entries.items as ContentfulItem<T>[];
            }

            return [];
        },
        {
            enabled: !!contentType && enabled,
            // MS -> Sec. -> Min. -> Hr. = 1 hour cache time.
            staleTime: 1000 * 60 * 60 * 1,
            cacheTime: 1000 * 60 * 60 * 1,
        }
    );
}
